import {
    OmValidationDateHelper,
    validateContactNumber,
    validateDateOfBirth,
    validateEmail,
    validateIdNumber,
    validatePassportNumber,
    validateSingleSelection,
} from '@om/validation';
import {
    validateAlphaNumericNotOnlyString,
    validateAlphaNumericString,
    validateAlphaNumericStringAllowingOnlyNumbers,
    validateAlphaNumericStringLenient,
    validateAlphaString,
    validateFullName,
    validateName,
    validateNameVTwo,
    validateNumericString,
} from '@om/validation/src/validators/string-validator';
import { setQuoteDetailsFieldValid, setQuoteDetailsValue } from '../../../actions/kaMetlhaFuneralCover/quote';
import { validateBwIdNumber } from '@om/validation/src/validators/bw-id-number-validator';
import { getQuoteForm } from '../../../selectors/kaMetlhaFuneralCover/quote';
import { FIELD_STATUS } from '../../../reducers/status';
import { validateDateOfBirthVTwo } from '@om/validation/src/validators/date-of-birth-validator';
import { KMF_COVER_CATEGORIES } from '../../../actions/kaMetlhaFuneralCover/types';
import { validateEmailAddress } from '@om/validation/src/validators/email-validator';
import { validatePassportNumberBw } from '@om/validation/src/validators/passport-validator';

export const quoteDetailsValidation = (store, next, action) => {
    const validationAction = (() => {
        const trimValue = (value) => (value ? value.trim() : value);
        const removeWhiteSpacesFromValue = (value) => (value ? value.replace(/ /g, '') : value);
        const {
            selectedCoverCategory,
            childHaveSpecialNeed,
            childIsStudent,
            email,
            cellphone,
            title,
            nationality,
            agentDetail,
            hearAboutUs,
            referFriendFamily,
        } = getQuoteForm(store.getState());

   const calculateAge = (dob) => {
  // Parse DD/MM/YYYY
  const [day, month, year] = dob.split("/").map(Number);
  const dobDate = new Date(year, month - 1, day);

  const now = new Date();

  if (isNaN(dobDate.getTime()) || dobDate > now) {
    return 0; // invalid or future date
  }

  let years = now.getFullYear() - dobDate.getFullYear();
  let months = now.getMonth() - (month - 1);
  let days = now.getDate() - day;

  // Adjust for incomplete month
  if (days < 0) {
    months -= 1;
  }

  // Total months difference
  let totalMonths = years * 12 + months;
  if (totalMonths < 0) return 0; // future date guard

  // If less than 1 year → return months in decimal form
  if (totalMonths < 12) {
    return +(totalMonths / 12).toFixed(1); // one decimal place
  }

  // Otherwise return whole years
  return Math.floor(totalMonths / 12);
};
        const getChildsMaxAgeCriteria = () => {
            if (childHaveSpecialNeed.value === 'Yes') {
                return 200;
            } else if (childIsStudent.value === 'Yes') {
                return 24;
            }
            return 20;
        };
        const ageCiteria = {
            [KMF_COVER_CATEGORIES.MYSELF]: 64,
            [KMF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY]: 64,
            [KMF_COVER_CATEGORIES.BENEFECIARY]: 119,
            [KMF_COVER_CATEGORIES.EXTENDED_FAMILY]: 74,
            ['Spouse']: 74,
        };

        const platforms = ['fromSomeone', 'omEmployee', 'broker', 'other'];
        let error;
        switch (action.value.fieldType) {
            case 'dateOfBirth':
                error =
                    selectedCoverCategory.value === 'Child'
                        ? validateDateOfBirthVTwo(action.value.value, {
                              min: 0,
                              max: 119,
                              subject: 'Date of birth',
                              includeMax: true,
                          })
                        : validateDateOfBirthVTwo(action.value.value, {
                              minInMonths: selectedCoverCategory.value === KMF_COVER_CATEGORIES.EXTENDED_FAMILY,
                              min: selectedCoverCategory.value === KMF_COVER_CATEGORIES.EXTENDED_FAMILY ? 1 : 18,
                              max: ageCiteria[selectedCoverCategory.value] ?? 74,
                              subject: 'Date of birth',
                              pronoun:""
                          });
                error ??
                    store.dispatch(
                        setQuoteDetailsValue({
                            fieldType: 'age',
                            value: calculateAge(action.value.value),
                            displayValue: null,
                        })
                    );
                break;
            // case 'childDateOfBirth':
            //     error = validateDateOfBirth(action.value.value, {
            //         min: 1,
            //         max: 21,
            //         subject: 'Date of birth',
            //     });
            //     error ?? store.dispatch(setQuoteDetailsValue({ fieldType:'age', value:calculateAge(action.value.value), displayValue:null }));
            //     break;
            case 'relationship':
                error = validateSingleSelection(action.value.value, 'RelationShip');
                break;
            case 'selectedCoverCategory':
                error = validateSingleSelection(action.value.value, 'Cover');
                break;
            case 'benefitsDetails':
                error = validateSingleSelection(action.value.value, 'response for a Cashback');
                break;
            case 'benefitsDetailsOnPremium':
                error = validateSingleSelection(action.value.value, 'response for a Premium paid up');
                break;
            case 'title':
                error = validateSingleSelection(action.value.value, 'Title');
                break;
            case 'nationality':
                error = validateSingleSelection(action.value.value, 'Nationality');
                break;
            case 'hearAboutUs':
                error = validateSingleSelection(action.value.value, 'option');
                break;
            case 'hearAboutUsPlatform':
                error = platforms.includes(hearAboutUs?.displayValue)
                    ? validateFullName(trimValue(action.value.value), {
                          min: 3,
                          max: 66,
                          subject: 'Full name',
                      })
                    : validateAlphaNumericString(action.value.value, {
                          max: 3,
                          min: 66,
                          subject: 'Text field',
                          required: true,
                      });
                break;

            case 'socialPlatform':
                error = validateSingleSelection(action.value.value, 'an option');
                break;
            case 'referFriendFamily':
                error = validateSingleSelection(action.value.value, 'an option');
                break;
            case 'referFullName':
                error = validateFullName(trimValue(action.value.value), {
                    min: 3,
                    max: 66,
                    subject: 'Full name',
                });
                break;
            case 'referCellphoneNumber':
                error = validateContactNumber(action.value.value, {
                    countryCode: 'bw',
                    leadingZeroValidation: false,
                    required: referFriendFamily?.value === 'No' ? false : true,
                });
                break;

            case 'childHaveSpecialNeed':
                error = validateSingleSelection(action.value.value, 'option');
                break;
            case 'childIsStudent':
                error = validateSingleSelection(action.value.value, 'option');
                break;
            case 'email':
                error = validateEmailAddress(action.value.value, {
                    min: 10,
                    max: 60,
                    subject: 'Email address',
                    required: false,
                });
                break;
            case 'cellphone':
                error = validateContactNumber(action.value.value, {
                    countryCode: 'bw',
                    leadingZeroValidation: false,
                    required: true,
                });
                break;
            case 'id':
                const getBoolean = () => selectedCoverCategory.value === KMF_COVER_CATEGORIES.BENEFECIARY;
                if (nationality.value === 'Botswana') {
                    error = validateBwIdNumber(action.value.value, {
                        min: 9,
                        max: 9,
                        required: getBoolean(),
                        subject: 'Botswana Id',
                        gender: title?.value === 'Mr.' ? 'Male' : 'Female',
                    });
                } else {
                    error = validatePassportNumber(action.value.value, {
                        required: getBoolean(),
                        subject: 'Passport Id',
                    });
                }
                break;

            case 'firstName':
                error = validateNameVTwo(action.value.value, { subject: 'first name', min: 3, max: 66 });
                break;

            case 'surname':
                error = validateNameVTwo(action.value.value, { subject: 'Surname', min: 3, max: 66 });
                break;

            case 'memberFromLivesCovered':
                error = validateSingleSelection(action.value.value, 'option');
                break;

            case 'beneficiaryName':
                error = validateSingleSelection(action.value.value, 'option');
                break;

            case 'agentDetail':
                error = validateSingleSelection(action.value.value, 'option');
                break;
            case 'agentCode':
                error = validateAlphaNumericStringAllowingOnlyNumbers(action.value.value, {
                    min: 1,
                    required: agentDetail.value==="Yes",
                    subject: 'agent code',
                });
                break;
            case 'currentResidence':
                error = validateSingleSelection(action.value.value, 'option');
                break;
            // case 'coverAmount':
            //     error = validateContactNumber(removeWhiteSpacesFromValue(action.value.value), {
            //         countryCode: 'bw',
            //         leadingZeroValidation: false,
            //     });
            //     break

            // case 'monthlyPremium':
            //    break
            // case 'addPartner':
            //     error = validateContactNumber(removeWhiteSpacesFromValue(action.value.value), {
            //         countryCode: 'bw',
            //         leadingZeroValidation: false,
            //     });
            //     break
            // case 'addChild':
            //     error = validateContactNumber(removeWhiteSpacesFromValue(action.value.value), {
            //         countryCode: 'bw',
            //         leadingZeroValidation: false,
            //     });
            //     break;

            default:
                return null;
        }

        return setQuoteDetailsFieldValid(error, action.value.fieldType);
    })();

    if (!validationAction) {
        return next(action);
    }

    store.dispatch(validationAction);
    return next(action);
};
